import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';

import { V_DEV_LIST, DeviceAlarmData, GetPlcStatuserrorList } from "./DeviceList";
import { TableUseStyle } from './DeviceListStyle';

type DeviceListStatErrorListDialogProps = {
  open: boolean;
  onClose: () => void;
  devListData: V_DEV_LIST;
};


const DeviceListStatErrorListDialog: React.FC<DeviceListStatErrorListDialogProps> = (props) => {
  const { t } = useTranslation();
  const classes = TableUseStyle();
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);
  const [deviceAlarmDataList, setIDeviceAlarmDataList] = useState<DeviceAlarmData[]>([]);

  useEffect(() => {
    if (props.open === true) {
      setButtonEnable(false);
      console.debug(['DeviceListStatErrorListDialog useEffect']);
      GetPlcStatuserrorList(props.devListData.DEV_INDEX.toString())
        .then((r) => {
          setIDeviceAlarmDataList(r);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setButtonEnable(true);
        });
    } else {
      setIDeviceAlarmDataList([]);
    }
  }, [props.open]);

  /**
     * エラー区分
     * @param sate
     * @returns
     */
  const getAlmKindText = (kind: Number): string => {
    if (kind == undefined) return t('DeviceListStatErrorListDialog.不明', '不明');
    switch (kind) {
      case 1:
        return t('DeviceListStatErrorListDialog.重故障', '重故障');
      case 2:
        return t('DeviceListStatErrorListDialog.軽故障', '軽故障');
      default:
        return t('DeviceListStatErrorListDialog.不明', '不明');
    }
  };

  return (
    <>
      <Dialog open={props.open} fullWidth={true} maxWidth={'md'}>
        <DialogTitle id="alert-dialog-title">
          {t('DeviceListStatErrorListDialog.ステータスアラームログ', 'ステータスアラームログ')}
        </DialogTitle>
        <DialogContent>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table stickyHeader aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeaderCell}>
                    {' '}
                    {t('DeviceListStatErrorListDialog.区分', '区分')}
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    {t('DeviceListStatErrorListDialog.項目名称', '項目名称')}
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    {t('DeviceListStatErrorListDialog.アラームコード', 'アラームコード')}
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    {t('DeviceListStatErrorListDialog.アラーム内容', 'アラーム内容')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {deviceAlarmDataList.map((row, index) => {
                  return (
                    <TableRow hover key={index}>
                      <TableCell className={classes.tableCell}>{getAlmKindText(row.ALM_SMM_DAT.ALM_KIND)}</TableCell>
                      <TableCell className={classes.tableCell}>{row.ALM_SMM_DAT.ITM_NAME}</TableCell>
                      <TableCell className={classes.tableCell}>{row.ALM_KIND_SET == null ? "" : row.ALM_KIND_SET.TYP_NAME}</TableCell>
                      <TableCell className={classes.tableCell}>{row.ALM_SMM_DAT.MESSAGE}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            disabled={!buttonEnable}
            disableElevation
            onClick={() => {
              props.onClose();
            }}
          >
            {t('DeviceListStatErrorListDialog.閉じる', '閉じる')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DeviceListStatErrorListDialog;